import type { LineDashPreset } from './model';

/** Map dash lengths are multiples of the effective line width. */
export const MAP_LINE_DASHES: Readonly<Record<LineDashPreset, number[]>> = {
  solid: [1, 0],
  dashed: [3, 2],
  shortDash: [1.5, 1.5],
  dotted: [0.1, 1.4],
  dashDot: [3, 1.5, 0.1, 1.5],
};
